var map = {
	"./logo_default.png": "5b7b",
	"./logo_冲锋狼.png": "f152",
	"./logo_北瓜.png": "c468",
	"./logo_千标.png": "0e6f",
	"./logo_华唯.png": "763c",
	"./logo_后博.png": "89d4",
	"./logo_天哲.png": "c0c5",
	"./logo_彭威.png": "65d9",
	"./logo_微信小程序(测试专用).png": "10a5",
	"./logo_微信小程序.png": "531f",
	"./logo_朋有.png": "d559",
	"./logo_标e选.png": "7fdb",
	"./logo_聚享.png": "24ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f92";